import { SectionQueryResult, SectionState } from "../types";

const LOADING: SectionState<never> = { state: "loading" };
const REQUEST_FAILED: SectionState<never> = {
  state: "unavailable",
  observedAt: null,
};

export const toSectionState = <T>({
  data,
  isError,
}: SectionQueryResult<T>): SectionState<T> => {
  if (!data) {
    return isError ? REQUEST_FAILED : LOADING;
  }
  return data.availability === "available"
    ? {
        state: "available",
        data: data.data,
        observedAt: data.observedAt,
        isRefreshFailed: isError,
      }
    : { state: "unavailable", observedAt: data.observedAt };
};
